import React, { useState } from "react";
import styled from "styled-components";

import { assertNativeError } from "@examspark/common";
import {
  Button,
  CautionBanner,
  Form,
  TextInput,
  VSpace,
} from "@examspark/common-ui";

import { useJoinWorkspace } from "../../hooks/useJoinWorkspace";

const Styled = styled.div`
  padding: 5rem;
`;

const JoinWorkspace = (props: {
  header: React.ReactNode;
  onJoin: (workspaceId: string) => void;
}) => {
  const [errorMessage, setErrorMessage] = useState<string>();
  const join = useJoinWorkspace();

  const handleSubmit = async () => {
    try {
      await join.handleSubmit();
      props.onJoin(join.workspaceId);
    } catch (error) {
      assertNativeError(error);
      setErrorMessage(error.message);
    }
  };

  return (
    <Styled>
      <VSpace size="3rem">
        {!!props.header && props.header}
        <div>
          <h1>One last step, then you're all set!</h1>
          <h2>
            Enter the campus information provided to you by Lowman Education to
            complete registration.
          </h2>
        </div>
        {!!errorMessage && <CautionBanner>{errorMessage}</CautionBanner>}
        <Form.FieldList>
          <Form.Field label="Workspace ID">
            <TextInput
              value={join.workspaceId}
              onChange={(e) => join.setWorkspaceId(e.target.value)}
              onEnterKeyPress={handleSubmit}
            />
          </Form.Field>
          <Form.Field label="Registration Code">
            <TextInput
              value={join.code}
              onChange={(e) => join.setCode(e.target.value)}
              onEnterKeyPress={handleSubmit}
            />
          </Form.Field>
          <div>
            <Button
              color="primary"
              title="Join"
              disabled={!join.isValid || join.isSubmitting}
              onClick={handleSubmit}
              isLoading={join.isSubmitting}
            >
              Join Workspace
            </Button>
          </div>
        </Form.FieldList>
      </VSpace>
    </Styled>
  );
};

export default JoinWorkspace;
